<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
    </div>
</template>

<script>
    export default {
        name: 'app',
        data(){
            return {
                isRouterAlive:true,
            }
        },
        provide () {
            return {
                reload: this.reload
            }
        },
        methods:{
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        },
        created:function(){
            var _hmt = _hmt || [];
            (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?62cf8b8319b389ffccfcdca6438bea16";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(hm, s);
            })();
        }
    }
</script>

<style lang="scss">
.two {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
a{
	color: inherit!important;
	text-decoration: inherit!important;
}
</style>

<style type="text/css">
    .pointer{cursor: pointer;}
    .list::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 1px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    .list::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 1px;
        box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
        background: rgba(29, 42, 156, 1);
    }

    .list::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.2);
        background: #fff;
        border-radius: 1px;
    }
</style>
